const Layout = () => import('@/layout/index.vue');
import uSvg from '@/assets/svg/u.svg';
import duoDianSvg from '@/assets/svg/dd.svg';

export default {
  path: '/config',
  name: 'Config',
  component: Layout,
  meta: {
    icon: 'tools',
    title: '配置信息',
    rank: 3,
    permission: ['root', 'admin']
  },
  children: [
    {
      path: '/u',
      name: 'U',
      component: () => import('@/views/config/u/index.vue'),
      meta: {
        icon: uSvg,
        iconType: 'svg',
        title: 'U的配置'
      }
    },
    {
      path: '/u_edit',
      name: 'U_edit',
      component: () => import('@/views/config/u_edit/index.vue'),
      meta: {
        icon: uSvg,
        iconType: 'svg',
        title: 'U的配置(新)'
      }
    },

    {
      path: '/product',
      name: 'Product',
      component: () => import('@/views/config/productEdit/index.vue'),
      meta: {
        icon: 'menu',
        title: '产品配置'
      }
    },
    {
      path: '/information',
      name: 'Information',
      component: () => import('@/views/config/information/index.vue'),
      meta: {
        icon: 'info-filled',
        title: '渠道配置'
      }
    },
    {
      path: '/ticketConfig',
      name: 'ticketConfig',
      component: () => import('@/views/config/ticketConfig/index.vue'),
      meta: {
        icon: 'ticket',
        title: '券码配置'
      }
    }
    // {
    //   path: '/duodian',
    //   name: 'Duodian',
    //   component: () => import('@/views/config/duodian/index.vue'),
    //   meta: {
    //     icon: duoDianSvg,
    //     iconType: 'svg',
    //     title: '多点券切换'
    //   }
    // }
  ]
};
